import { Create, SimpleForm } from "react-admin";
import SaveForm from "./Partials/SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreatePostgraduateCourses = () => (
  <Create
    actions={<BackButtonToolbar />}
    title="Създаване на следдипломен курс"
    transform={data => {
      return {
        ...data,
        courses:
          data?.courses?.map(course => {
            const commonFields = {
              description: course.description,
              durationInCalendarDays: course.durationInCalendarDays === null ? "" : course.durationInCalendarDays,
              startDate: course.startDate,
              maxParticipants: course.maxParticipants === null ? "" : course.maxParticipants,
              buildingIds: course.buildingIds,
              supervisorsEmployeeIds: course.supervisorsEmployeeIds,
              note: course.note === null ? "" : course.note,
            };

            if (course?.isDefinedCourse) {
              return {
                typeId: course.typeId,
                name: course.name,
                clinicId: course.clinicId,
                ...commonFields,
              };
            } else {
              return {
                definitionId: course.definitionId,
                ...commonFields,
              };
            }
          }) || [],
      };
    }}
  >
    <SimpleForm>
      <SaveForm />
    </SimpleForm>
  </Create>
);

export default CreatePostgraduateCourses;
